import { styled } from '@glitz/react';
import * as React from 'react';

import type { JSX } from 'react';

export const highlightText = (text: string, textToHighlight: string[]): string | JSX.Element[] => {
  let index = 0;
  const bold = (textArg: string) => {
    index++;
    return <Highlight key={textArg + index}>{textArg}</Highlight>;
  };

  const span = (textArg: string) => {
    index++;
    return <span key={textArg + index}>{textArg}</span>;
  };

  // escape regex breaking chars
  textToHighlight = textToHighlight.map(t => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'));

  textToHighlight = textToHighlight.filter(t => t.length > 1);
  if (!textToHighlight.length) {
    return text;
  }
  const regex = new RegExp('(' + textToHighlight.sort((a, b) => b.length - a.length).join('|') + ')', 'ig');

  const parts: JSX.Element[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  do {
    match = regex.exec(text);
    if (match) {
      if (lastIndex > 0) {
        parts.push(span(' '));
      }
      parts.push(bold(match[1]));
      lastIndex = regex.lastIndex;
    }
  } while (match);
  parts.push(span(text.substring(lastIndex)));
  return parts;
};

const Highlight = styled.span({
  color: t => t.quickSearch?.highlightText,
});
